const organization = {
    require_membership: 'Der Benutzer muss Mitglied der Organisation sein, um fortzufahren.',
    role_names_not_found: 'Ungültige Rollennamen erkannt: {{names,list(type:conjunction)}}. Bitte erstelle diese Rollen zuerst, bevor du fortfährst.',
};
export default Object.freeze(organization);
